export const SET_NAV = 'set_nav';

export const PROCESSING = "processing";
export const FORM_PROCESSING = "form_processing";
export const COMPLETED = "completed";

export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';

export const LOAD_DATA = "load_data";
export const LOAD_FILTERED_DATA = "LOAD_FILTERED_DATA";
export const DATA_ERROR = "data_error";

export const SET_MESSAGES = "set_messages";

export const DB_TYPE = "db_type";

export const DB_LIST = "db_list";

export const RESIZE = "resize";

export const LOADING_FILES = "LOADING_FILES";
export const FILE_LOAD_FAILED = "FILE_LOAD_FAILED";
export const FILE_LOAD_SUCCESS = "FILE_LOAD_SUCCESS";
export const UPDATE_CHECKS = "UPDATE_CHECKS";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";

export const TOGGLE_DELETE = "TOGGLE_DELETE";



// WEBPACK FOOTER //
// ./src/actions/types.js